import moment from 'moment';
import React from 'react';

import Json from 'components/Json';
import { DATE_TIME_FORMAT } from '../../../constants';

const CarrierRequestsTable = ({ carrierRequests }) => {
  const renderTableRow = ({
    id,
    driver,
    action,
    status,
    errors,
    sent_at,
    request_duration,
  }) => {
    return (
      <tr key={id}>
        <td>{driver}</td>
        <td>{action}</td>
        <td>{status}</td>
        <td style={{ maxWidth: '300px' }}>
          <Json data={errors} />
        </td>
        <td>{sent_at ? moment(sent_at).format(DATE_TIME_FORMAT) : sent_at}</td>
        <td>{request_duration}</td>
      </tr>
    );
  };

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Driver</th>
          <th>Action</th>
          <th>Status</th>
          <th>Errors</th>
          <th>Sent At</th>
          <th>Request Duration</th>
        </tr>
      </thead>
      <tbody>
        {carrierRequests?.length ? (
          carrierRequests.map(renderTableRow)
        ) : (
          <tr>
            <td colSpan="6">No results</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default CarrierRequestsTable;
